import V2Adapter from './v2';

export default class extends V2Adapter {
  pathForType() {
    // We overwrite `pathForType` because `location-export-job`
    // is simply a wrapper over `entry-export-jobs`
    return 'entry-export-jobs';
  }
}
